import { render, staticRenderFns } from "./extract-musical..vue?vue&type=template&id=335a0cd4"
import script from "./extract-musical..vue?vue&type=script&lang=js"
export * from "./extract-musical..vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports